exports.shouldApplyAuth = (isApiAuthEnabled, bypassWhitelist, uri, credential) => {
  const bypassAuth =
    isApiAuthEnabled &&
    !!bypassWhitelist &&
    bypassWhitelist.length > 0 &&
    bypassWhitelist.some((bypassRegex) => new RegExp(bypassRegex).test(uri));

  return isApiAuthEnabled && !bypassAuth && !!credential && /^\//.test(uri); // Only apply authorization header to same-origin request which start with /
};
